import React from "react"
import connect from "./connect"
import QuickLink from "../BurgerQuickLink"
import {QUICKLINK_TYPE, BURGER_QUICKLINK_TYPE} from "../../config/constants"

export type MyAccountProps = {
    accessibilityText: string | null
    myAccountText: string | null
    icon: string | null
    description: string | null
    url: string
    isLoggedIn: boolean
}

export const BurgerMyAccount = ({
    accessibilityText,
    myAccountText,
    icon,
    description,
    url,
    isLoggedIn,
}: MyAccountProps) => {
    if (!myAccountText) return null
    return (
        <QuickLink
            href={url}
            iconSrc={icon}
            iconAltText={accessibilityText || ""}
            title={myAccountText}
            description={description || ""}
            type={QUICKLINK_TYPE.LINK}
            linkType={BURGER_QUICKLINK_TYPE.MYACCOUNT}
            maskTitle={isLoggedIn}
        />
    )
}

export default connect(BurgerMyAccount)
